import React from 'react';
import { Accent } from './SectionHeading';
import { bonuses } from '../../data/content';

/** Extra bonuses as text — deliberately lighter than the core volumes. */
export function BonusesSection() {
  return <section aria-labelledby="bonus-heading" className="border-t border-brand-plum/10 bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-42" data-mp="16m0sh7s6jrak">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="1bhzdcleaur68">
        <div className="mx-auto max-w-2xl text-center" data-id="element-44" data-mp="wms36s89f0uj">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-45" data-mp="wpeaqrv5hgcr">
            And There's More
          </p>
          <h2 id="bonus-heading" className="mt-4 font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]" data-id="element-46" data-mp="nneva3zsakbx">
            Get 5 Extra Teaching Resources <Accent data-id="element-47" data-mp="2i1pk4cgdpehp">Included</Accent>
          </h2>
        </div>

        <ol className="mt-12 rounded-[20px] bg-white px-6 sm:px-8" role="list" data-id="element-48" data-mp="2mz7lnhs2grfo">
          {bonuses.map(bonus => <li key={bonus.number} className="grid gap-1 border-b border-brand-charcoal/10 py-5 last:border-b-0 sm:grid-cols-[110px_1fr] sm:gap-6" data-id="element-49" data-mp="1k7276fkikc2e">
              <p className="pt-0.5 font-body text-[11px] font-bold uppercase tracking-[0.18em] text-brand-plum" data-id="element-50" data-mp="1ty6ldd2d7sw6">
                {bonus.number}
              </p>
              <div data-id="element-51" data-mp="1p0wojccnceyb">
                <h3 className="font-body text-[15px] font-semibold leading-snug text-brand-charcoal" data-id="element-52" data-mp="118pwuqhv8w58">{bonus.title}</h3>
                <p className="mt-1 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-53" data-mp="x8621tkrm4m9">{bonus.description}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-54" data-mp="1682ix90wxz6r">
          The bonuses expand your teaching library.{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-55" data-mp="2mkhmqpxspxu1">
            The 6 professional volumes remain the heart of Makeup Instructor Ready.
          </strong>
        </p>
      </div>
    </section>;
}